<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Wells of Knowledge</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Commission, hybrid publication, data visualisation, web development, web design, print design</p>
        <p>This hybrid publication focuses on the transfer of knowledge through cultural production in the oral folkloric traditions of Anatolia.</p>
        <p>The work was commissioned by the Hybrid Publishing department of WDKA and consists of a digital <a href="https://wellsofknowledge.wdka.nl/">interactive platform</a> and a poster-zine.</p>

        <p>The project was developed together with Ageliki Diakrousi based on the work of Merve Kılıçer.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/wells.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/wells/wells3.png"></b-img>


      </b-col>
      <b-col md="4">
        <b-img class="img-fluid" src="media/wells/wellsgif1.gif"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/wells/wellsgif2.gif"></b-img>


      </b-col>


    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'WellsPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
